/** Returns true only for the newest snapshot request sequence. */
export function shouldApplySnapshotSeq(requestSeq: number, latestSeq: number): boolean {
  return requestSeq === latestSeq;
}

/** Guards a queued result by both request order and the currently selected day. */
export function shouldApplySnapshotRequest(
  requestSeq: number,
  latestSeq: number,
  requestDay: string,
  selectedDay: string | null,
): boolean {
  return shouldApplySnapshotSeq(requestSeq, latestSeq) && requestDay === selectedDay;
}

/** Decides whether the selected day must be resolved again for the snapshot map. */
export function shouldResolveSnapshotDay(
  selectedDay: string,
  resolvedDay: string | null,
  hasResolvedState: boolean,
  force: boolean,
): boolean {
  return force || selectedDay !== resolvedDay || !hasResolvedState;
}
